import { render, staticRenderFns } from "./PlacementBookingRescheduleTableForm.vue?vue&type=template&id=1e9b0da4"
import script from "./PlacementBookingRescheduleTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementBookingRescheduleTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports